// Lightweight localStorage cache for event capacities/sold

const STORAGE_KEY = 'hchs_event_status_map_v1';

/**
 * Why an event can no longer take RSVPs, or null if it's still open.
 *
 * Kept as a pure function (the caller passes the event's sort date and its
 * fetched status) so it can be unit-tested without rendering the RSVP page.
 *
 * @param {object} event    the event record
 * @param {Date}   sortDate result of getEventSortDate(event)
 * @param {object} status   { capacity, remaining } from the API, or null
 * @param {Date}   now      injectable for tests
 * @returns {'past'|'closed'|'full'|null}
 */
export function getRsvpClosedReason(event, sortDate, status, now = new Date()) {
	if (!event) return 'closed';
	if (event.isClosed) return 'closed';
	// An event that has already happened must never take money — without this,
	// a bookmarked /rsvp/<past-slug> link stays live and charges current prices.
	if (sortDate instanceof Date && sortDate < now) return 'past';
	if (status && status.capacity != null && status.remaining <= 0) return 'full';
	return null;
}

export function loadEventStatusesFromStorage() {
	try {
		const raw = localStorage.getItem(STORAGE_KEY);
		if (!raw) return {};
		const parsed = JSON.parse(raw);
		return parsed && typeof parsed === 'object' ? parsed : {};
	} catch (_) {
		return {};
	}
}

export function saveEventStatusesToStorage(statusMap) {
	try {
		if (!statusMap || typeof statusMap !== 'object') return;
		localStorage.setItem(STORAGE_KEY, JSON.stringify(statusMap));
	} catch (_) {
		// ignore
	}
}

export function upsertEventStatusInStorage(slug, partial) {
	try {
		const current = loadEventStatusesFromStorage();
		const existing = current[slug] || { slug, capacity: null, sold: 0, remaining: null };
		const next = { ...existing, ...partial };
		current[slug] = next;
		saveEventStatusesToStorage(current);
		return next;
	} catch (_) {
		return null;
	}
}


